import React from 'react'

import { StyledLogo } from '../styled'

const Logo = () => <StyledLogo strong>Metadata - FoodStyles</StyledLogo>
export default Logo
